export const article = {
  id: 8,
  title: "Sample Article with Images",
  slug: "sample-article-with-images",
  date: "December 23, 2024",
  excerpt: "This is a sample article demonstrating how to include images and complex HTML content in individual article files.",
  content: `# Sample Article with Images

This is a demonstration of how you can now create more complex blog articles with images and rich content.

## Adding Images

You can now easily add images to your articles by:

1. **Placing images in the public folder**: \`public/images/articles/\`
2. **Referencing them in your content**: \`![Alt text](/images/articles/sample-image.jpg)\`
3. **Using relative paths**: \`./images/sample-image.jpg\`

## Example Image

![Sample Image](/images/articles/sample-image.jpg)

## Rich Content Support

With this new structure, you can:

- Use **markdown formatting**
- Include *italic text*
- Add \`code snippets\`
- Create lists and tables
- Embed videos and other media

## Benefits of This Structure

1. **Modularity**: Each article is in its own file
2. **Maintainability**: Easy to update individual articles
3. **Scalability**: Simple to add new articles
4. **Rich Content**: Support for images, videos, and complex formatting
5. **Version Control**: Better tracking of changes per article

## Future Enhancements

This structure makes it easy to add:
- Article-specific CSS styles
- Interactive components
- Dynamic content loading
- SEO optimization per article`,
  author: "Sourov Roy",
  readTime: "3 min read",
  category: "Technology",
  tags: ["Sample", "Structure", "Images"],
  language: "english" as const
};
